import * as React from 'react';
import { toast } from 'react-toastify';
import { checkForUnAuthorizedException, stringIsNullOrEmpty, formatNumber } from '../Common/Utilities';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import { getFilter, setFilter, getInvoiceModuleName } from '../Common/Utilities';
import { isNewUi } from '../../redesign/uiMode';
import StatusTabs from '../../redesign/lists/StatusTabs';
import { paymentTabs, rowsForPayment, savedPaymentTab, savePaymentTab, arrangePaymentColumns } from '../../redesign/lists/paymentList';

export default class PaymentDashboard extends React.Component {
	constructor() {
		super();
		const userInfo = JSON.parse(localStorage.userInfo);
		this.isAdmin = userInfo.selectedUserRoles.isAdmin;

		this.state = {
			paymentDashboard: [],
			filterText: '',
			sortModel: [],
			apw2Tab: null // new UI: the payment status tab (redesign/lists/paymentList.js)
		};
		this.mainGridRef = React.createRef();

	}

	componentDidMount() {
		const moduleName = getInvoiceModuleName(this.props.modelDefId);
		const filterText = getFilter([moduleName, "PaymentDashboard", "searchText"]) || '';
		const sortModel = getFilter([moduleName, "PaymentDashboard", "sortModel"]) || [];

		this.setState({ filterText, sortModel }, () => {
			this.fetchPaymentDashboard(); 
			const gridRef = this.mainGridRef?.current;
			if (gridRef && typeof gridRef.setQuickFilterValues === 'function') {
				gridRef.setQuickFilterValues([this.state.filterText]);
			}
		});
	}

	fetchPaymentDashboard() {
		const that = this;
		var modelDefId = this.props.modelDefId;

		this.props.inProgress(true);

		httpGet("/api/dashboard/appayments/" + modelDefId)
			.then((response) => {
				var data = response.data;

				var paymentDashboard = data;

				this.setRowId(paymentDashboard);

				this.setState({ paymentDashboard: paymentDashboard });

				this.props.inProgress(false);
			}).catch((error) => {
				checkForUnAuthorizedException(that, error);
				this.props.inProgress(false);

				toast.error('An error occurred while fetching the records');
				console.error('There was an error!', error);
			});
	}

	setRowId(data) {
		var rowId = 1;
		data.map(row => row.rowId = rowId++);
	}
	displayVendorName(rowData) {
		return stringIsNullOrEmpty(rowData.vendorName) ? rowData.vendorCode : rowData.vendorName;
	}
	render() {
		const fontSize = 12;
		const cellStyle = { fontSize: fontSize, padding: 8 };
		const fontStyle = { fontSize: fontSize, padding: 8 };

		const tableOptions = {
			pageSize: 10,
			pageSizeOptions: [10, 20, 30, 40, 50],
			minBodyHeight: 320,
			maxBodyHeight: 670,
			headerStyle: fontStyle,
			searchFieldStyle: fontStyle
		};

		// New UI (docs/ui_redesign/14-screen-concepts.md): tabs by payment status over the same list, and the payment
		// columns moved forward. Classic renders the grid as it is.
		const newUi = isNewUi();
		const tab = this.state.apw2Tab || savedPaymentTab(this.props.modelDefId);
		const arrange = columns => (newUi ? arrangePaymentColumns(columns) : columns);

		const grid = (
			<EnhancedDataGrid
				gridRef={this.mainGridRef}
				initialQuickFilter={this.state.filterText}
				rows={newUi ? rowsForPayment(this.state.paymentDashboard, tab) : this.state.paymentDashboard}
				disableColumnMenu
				pagination
				pageSize={10}					
				columnVisibilityModel={{
					//'mediaPlanName': this.props.info.modelDefId === 1,//hide: this.props.info.modelDefId === 2,	
					//'deliveryAmount': this.props.info.modelDefId === 1,//hide: this.props.info.modelDefId === 2,
					'jobCode':this.props.modelDefId === 2,//hide: (this.props.modelDefId !== 2),
					'activityCode': this.props.modelDefId === 2,//hide: (this.props.modelDefId !== 2),
					'campaignName': this.props.modelDefId !== 2,//hide: (this.props.modelDefId === 2),
					'mediaPlanName': this.props.modelDefId !== 2,//hide: (this.props.modelDefId === 2),
				}}
				setFilterText={(text) => {
					const trimmed = text?.trim() || '';
					this.setState({ filterText: trimmed });

					setFilter([getInvoiceModuleName(this.props.modelDefId), "PaymentDashboard", "searchText"], trimmed);
				}}
				highlightSearchTextOnMainScreenGrid={true}
				onSortModelChange={(model) => {
					this.setState({ sortModel: model });
					setFilter([getInvoiceModuleName(this.props.modelDefId), 'PaymentDashboard', 'sortModel'], model);
				}}
				sortModel={this.state.sortModel}
				columns={arrange([
					{
						headerName: 'Vendor Name',
						field: 'vendorName',
						renderCell: rowData => { return this.displayVendorName(rowData.row); },
						width:150
					},
					{
						headerName: 'Vendor Invoice Number',
						field: 'invoiceNumber',
						width: 150
					},
					{
						headerName: 'Vendor Invoice Date',
						field: 'invoiceDate',
						type: 'date',
						valueGetter: ({value})=>value && new Date(value),
						width: 150
					},
					{
						headerName: 'Last Approved By',
						field: 'approvedBy',
						width: 150
					},
					{
						headerName: 'Campaign Name',
						field: 'campaignName',
						//hide: (this.props.modelDefId === 2),
						width: 150
					},
					{
						headerName: 'Media Plan',
						field: 'mediaPlanName',
						//hide: (this.props.modelDefId === 2),
						width: 150
					},
					{
						headerName: 'Job',
						field: 'jobCode',
						//hide: (this.props.modelDefId !== 2),
						width: 100
					},
					{
						headerName: 'Activity',
						field: 'activityCode',
						//hide: (this.props.modelDefId !== 2),
						width: 150
					},
					{
						headerName: (this.props.modelDefId === 2 ? 'PO' : 'IO'),
						field: 'ioNumber',
						width: 100
					},
					{
						headerName: 'Amount',
						field: 'amount',
						type: 'currency',
						headerAlign: 'right',
						align: 'right',
						renderCell: rowData => formatNumber(rowData.row.amount) + " " + rowData.row.currencyCode,
						width: 100
					},
					{
						headerName: 'Posted Date',
						field: 'postedDate',
						type: 'date',
						
						valueGetter: ({value})=>value && new Date(value),
						width: 150
					},
					{
						headerName: 'Payment Status',
						field: 'paymentStatus',
						cellStyle: cellStyle,
						width: 100
					},
					{
						headerName: 'Payment Amount',
						field: 'paymentAmount',
						type: 'currency',
						headerAlign: 'right',
						align: 'right',
						renderCell: rowData => formatNumber(rowData.row.paymentAmount) + " " + rowData.row.currencyCode,
						width: 150
					},
					{
						headerName: 'Payment Info',
						field: 'paymentInfo',
						width: 150
					}
				])}
				getRowId={(row) => row.rowId}
				disableSelectionOnClick
			/>
		);

		return (
			<div>
				<h1>{this.props.modelDefId === 1 ? 'Media' : (this.props.modelDefId === 2 ? 'Production' : 'Broadcast')} Payment Dashboard</h1>
				<div className="form-group">
					<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
						{newUi ? (
							<div className="apw2-listcard">
								<StatusTabs label="Payments by status" controls="apw2-payment-list" value={tab} tabs={paymentTabs(this.state.paymentDashboard)}
									onChange={key => { savePaymentTab(this.props.modelDefId, key); this.setState({ apw2Tab: key }); }} />
								<div className="apw2-listcard-grid" id="apw2-payment-list" role="tabpanel" aria-labelledby={'apw2-stab-' + tab}>{grid}</div>
							</div>
						) : grid}
					</div>
					
				</div>
			</div >
		);
	}
}
